function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M-14.312,282.7l-.41.41a.259.259,0,0,1-.188.082.259.259,0,0,1-.188-.082l-3.819-3.819A.259.259,0,0,1-19,279.1a.259.259,0,0,1,.082-.188l3.819-3.819a.259.259,0,0,1,.188-.082.259.259,0,0,1,.188.082l.41.41a.259.259,0,0,1,.082.188.259.259,0,0,1-.082.189l-3.221,3.221,3.221,3.221a.259.259,0,0,1,.082.189A.259.259,0,0,1-14.312,282.7Zm4.843-8.744-3.057,10.58a.266.266,0,0,1-.127.16.229.229,0,0,1-.193.021l-.508-.139a.267.267,0,0,1-.16-.127.245.245,0,0,1-.02-.2l3.057-10.58a.266.266,0,0,1,.127-.16.229.229,0,0,1,.193-.021l.508.139a.267.267,0,0,1,.16.127A.245.245,0,0,1-9.469,273.956Zm5.384,5.335L-7.9,283.11a.259.259,0,0,1-.188.082.259.259,0,0,1-.188-.082l-.41-.41a.259.259,0,0,1-.082-.188.259.259,0,0,1,.082-.189L-5.47,279.1l-3.221-3.221a.259.259,0,0,1-.082-.189.259.259,0,0,1,.082-.188l.41-.41a.259.259,0,0,1,.188-.082.259.259,0,0,1,.188.082l3.819,3.819A.259.259,0,0,1-4,279.1.259.259,0,0,1-4.085,279.291Z",
  transform: "translate(19.25 -273.225)",
  stroke: "currentColor",
  strokeWidth: 0.5
});

function SvgCodeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.497,
    height: 11.754,
    viewBox: "0 0 15.497 11.754",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodeIcon);
export default __webpack_public_path__ + "static/media/CodeIcon.3ab656e2.svg";
export { ForwardRef as ReactComponent };